import React from 'react';
import {AlertList} from 'react-bs-notifier';
import {apiGet, apiPost} from '../../../services/apiClient';
import InformationModal from '../../../modals/infoModal.jsx';
import WarningModal from '../../../modals/warningModal.jsx';
import ConfirmModal from '../../../modals/confirmModal.jsx';
import CostCalcTab from './tabs/costCalcTab.jsx';
import PayerTab from './tabs/payerTab.jsx';
import HistoryTab from './tabs/historyTab.jsx';
import Forbidden from '../../forbidden/forbidden.jsx';
import NotFound from '../../notFound/notFound.jsx';
import {isNullOrUndefined} from 'util';
import Status from "./status";
import {Button, Dimmer, Loader, Menu, Segment, Tab} from "semantic-ui-react";
import CopyString from "./copyString";
import Logos from "./logos";
import CarrierReviewRating from "../../../components/CarrierReview/CarrierReviewRating";
import Info from "../../../components/Info";
import moment from "moment";
import MapModal from "./mapModal";
import {costFormat} from "../../../services/cost";
import ParcelInfoTab from "./tabs/parcelInfoTab";
import DocsTab from "./tabs/docsTab";
import {toast} from "react-toastify";
import InnModal from "./innModal";
import {buildParcelExternalTrackingUrl} from "../../../services/trackingLink";
import StatusChangeModal from "../../../grids/statusChangeModal";

export default class ParcelForm extends React.Component {
    constructor(args) {
        super(args);

        this._isMounted = false;
        this.costCalcTab = null;
        this.payerTab = null;
        this.historyTab = null;

        this.confirmChangeStatusModal = null;
        this.infoModal = null;
        this.warningModal = null;

        let isNew = this.props.location.state && this.props.location.state.isNew;

        this.state = {
            id: this.props.match.params.id,
            isNew: isNew,
            busyCount: 0,
            lastResponseError: null,
            errors: {},
            parcel: {},
            initParcel: {},
            history: [],
            documents: [],
            nextStatuses: [],
            alerts: [],
            activeTab: "parcelInfo",
            maps: {open: false},
            options: {
                parcelTypes: {
                    parcelTypeDoc: 1,
                    parcelTypeCargo: 2
                }
            },
            companyData: {}
        };
    }

    loadCompanyData = () => {
        this.updateBusyCount(5);
        apiGet('ref/parceltypes/list')
            .then(data => {
                let parcelTypeDoc = 0;
                let parcelTypeCargo = 0;
                data.entries.map((entry) => {
                    if (entry.name === "Document") {
                        parcelTypeDoc = entry.id;
                    } else if (entry.name === "Cargo") {
                        parcelTypeCargo = entry.id;
                    }
                });

                this.setState((prevState) => {
                    prevState.options.parcelTypes = {
                        parcelTypeDoc,
                        parcelTypeCargo
                    };
                    return prevState;
                });
                this.updateBusyCount(-1);
            })
            .catch(err => {
                this.updateBusyCount(-1);
                console.log(err)
            });
        apiGet('user/company')
            .then(data => {
                this.setState((prevState) => {
                    prevState.companyData = data;
                    return prevState;
                });
                this.updateBusyCount(-1);
            })
            .catch(err => {
                this.updateBusyCount(-1);
                console.log(err);
            });

        apiGet('ref/vehicletypes/list/' + this.state.parcel.companyId)
            .then(data => {
                this.setState((prevState) => {
                    prevState.options.vehicleTypes = data.entries.map((entry) => {
                        if (entry.name === 'Курьерская доставка (без режима)') {
                            prevState.courierDeliveryId = entry.id;
                        }
                        return {key: entry.id, value: entry.id, text: entry.name};
                    });
                    return prevState;
                });
                this.updateBusyCount(-1);
            })
            .catch(err => {
                this.updateBusyCount(-1);
                console.log(err);
            });

        apiGet('ref/deliverytypes/list/')
            .then(data => {
                this.setState((prevState) => {
                    prevState.options.deliveryTypes = data.entries.map((entry) => {
                        return {key: entry.code, value: entry.id, text: entry.name};
                    });
                    return prevState;
                });
                this.updateBusyCount(-1);
            })
            .catch(err => {
                this.updateBusyCount(-1);
                console.log(err);
            });
        apiGet('ref/carrierServices/list/')
            .then(data => {
                data.entries && this.setState((prevState) => {
                    prevState.options.carrierServices = data.entries.map((e) => {
                        return {
                            value: e.code,
                            name: e.name,
                            info: e.description
                        };
                    });
                    return prevState;
                });
                this.updateBusyCount(-1);
            })
            .catch(err => {
                this.updateBusyCount(-1);
                console.log(err)
            });
    }

    componentDidMount() {
        this._isMounted = true;
        this.reload()
            .then(() => {
                if (!this._isMounted) return;
                this.loadCompanyData();
                if (this.props.location.state && this.props.location.state.info) {
                    this.infoModal.open(null, this.props.location.state.info)
                    this.props.history.replace({...this.props.location, state: null});
                }
                if (this.props.location.hash) {
                    this.openTab(this.props.location.hash.replace('#', ''))
                }
                else if (this.state.isNew) {
                    let hasDocuments = this.state.documents && this.state.documents.length > 0;
                    if (hasDocuments) {
                        this.openTab("docs");
                        this.setState((prevState, props) => {
                            this.generateNewDocumentsAlert();
                            return prevState;
                        });
                    }
                }
                $('[data-toggle="popover"]').popover();
            });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.location.hash !== prevProps.location.hash) {
            this.openTab(this.props.location.hash.replace('#', ''));
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.state.id !== newProps.match.params.id) {
            this.setState(
                {
                    id: newProps.match.params.id,
                    isNew: false,
                    errors: {}
                },
                () => this.reload()
            );
        }
    }

    updateBusyCount(inc) {
        if (!this._isMounted) return;
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    reload() {
        return this.reloadParcelData()
            .then(() => {
                if (!this._isMounted) return;
                let loadPayer = this.payerTab && this.payerTab.reloadReferences();
                let loadCostCalc = this.costCalcTab && this.costCalcTab.reloadReferences();
                let loadHistory = this.reloadHistory();
                let loadDocuments = this.reloadDocuments();

                return Promise.all([loadPayer, loadCostCalc, loadHistory, loadDocuments])
                    .then(() => {
                        if (!this._isMounted) return;
                        this.validateAll();
                    });
            })
            .catch((e) => {
                console.log(e)
            });
    }

    reloadHistory() {
        this.updateBusyCount(1);
        return apiGet('parcels/' + this.state.id + '/history')
            .then(data => {
                if (!this._isMounted) return;
                this.updateBusyCount(-1);
                this.setState({history: data.entries});
            })
            .catch(err => {
                if (!this._isMounted) return;
                this.updateBusyCount(-1);
            });
    }

    reloadDocuments() {
        this.updateBusyCount(1);
        return apiGet('parcels/documents/' + this.state.id + '/list')
            .then(data => {
                if (!this._isMounted) return;
                this.updateBusyCount(-1);
                this.setState({documents: data.entries});
            })
            .catch(err => {
                if (!this._isMounted) return;
                this.updateBusyCount(-1);
            });
    }

    reloadParcelData() {
        this.updateBusyCount(1);
        apiGet('parcels/' + this.state.id + '/status/next')
            .then(data => {
                if (!this._isMounted) return;
                if (data && data.warningMessages) {
                    toast.warning(data.warningMessages, {autoClose: 30000});
                }
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.nextStatuses = data.entries;
                    return prevState;
                });
            })
            .catch(err => {
                if (!this._isMounted) return;
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        return apiGet('parcels/' + this.state.id)
            .then(data => {
                if (!this._isMounted) return;
                data.statusCode === 'Created' && this.props.history.push(`/parcels/draft/${this.state.id}`)
                if (data.carrierCostRequests) {
                    data.carrierCostRequests.forEach((entry, ind, arr) => {
                        if (entry.isSelected) {
                            entry.isDeliveryTimeSpecified = data.isDeliveryTimeSpecified;
                            entry.deliveryTime = data.deliveryTime;
                        }
                    });
                }
                let initValue = $.extend(true, {}, data);
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.parcel = data;
                    prevState.initParcel = initValue;
                    return prevState;
                });
            })
            .catch(err => {
                if (!this._isMounted) return;
                this.updateBusyCount(-1);
                if (err.status > 401) {
                    this.setState({lastResponseError: err.status});
                }
            });
    }

    clearErrors() {
        this.setState({errors: {}});
    }

    backToList() {
        // Получаем параметр cameFrom из URL
        const urlParams = new URLSearchParams(window.location.search);
        const cameFrom = urlParams.get('cameFrom');
        
        if (cameFrom === 'reports') {
            this.props.history.push('/reports/my');
        } else if (cameFrom === 'parcels') {
            this.props.history.push('/parcels/list/new');
        } else {
            // Fallback на referrer если параметр не найден
            this.fallbackNavigation();
        }
    }


    fallbackNavigation() {
        const referrer = document.referrer;
        const currentHost = window.location.host;
        
        if (referrer && referrer.includes(currentHost)) {
            if (referrer.includes('/parcels/list/new') || referrer.includes('/parcels/list')) {
                this.props.history.push('/parcels/list/new');
            } else if (referrer.includes('/reports/my') || referrer.includes('/reports')) {
                this.props.history.push('/reports/my');
            } else {
                this.props.history.push('/parcels/list/new');
            }
        } else {
            this.props.history.push('/parcels/list/new');
        }
    }

    openTab(tabName) {
        this.setState({activeTab: tabName});
    }

    syncInitState() {
        this.setState({
            initParcel: $.extend(true, {}, this.state.parcel)
        });
    }

    validateAll() {
        let errors = {};
        let costCalcErrors = this.costCalcTab.validateForm();
        if (costCalcErrors) {
            $.extend(true, errors, costCalcErrors);
        }
        let payerErrors = this.payerTab && this.payerTab.validateForm();
        if (payerErrors) {
            $.extend(true, errors, payerErrors);
        }
        this.setState({errors: errors});
        return $.isEmptyObject(errors);
    }

    handleFieldEdited(fieldName, value, ignoreValidation) {
        let initValue = this.state.initParcel[fieldName];
        if (value === initValue) {
            return;
        }

        if (!ignoreValidation) {
            let errors = this.costCalcTab.validateForm(fieldName);
            if (!errors && this.payerTab) {
                errors = this.payerTab.validateForm(fieldName);
            }

            if (errors) {
                console.log(this.validateAll)
                this.validateAll();
                return;
            }
        }

        this.updateBusyCount(1);
        let request = {
            fieldName: fieldName,
            value: value
        };
        apiPost('parcels/' + this.state.id + '/field', request)
            .then(data => {
                this.updateBusyCount(-1);
                if (data.needReload) {
                    this.reload();
                } else {
                    this.reloadHistory();
                    this.validateAll();
                }
                this.syncInitState();
            })
            .catch(err => {
                this.updateBusyCount(-1);
                this.validateAll();
                if (err.error) {
                    this.setState((prevState, props) => {
                        prevState.errors[fieldName] = err.error;
                        return prevState;
                    });
                }
            });
    }

    handleFieldChange(newFieldValues) {
        let promise = new Promise((resolve, reject) => {
            let parcel = this.state.parcel;
            newFieldValues.map((field, ind, arr) => {
                parcel[field.name] = field.value;
            });
            this.setState(
                {parcel: parcel},
                () => resolve()
            );
        });
        return promise;
    }

    setErrors(errors) {
        if (errors) {
            let newErrors = this.state.errors;
            errors.forEach((item, int, arr) => {
                newErrors[item.name] = item.value;
            });
            this.setState({errors: newErrors});
        }
    }

    dismissAlert(alert) {
        this.setState((prevState, props) => {
            let newAlerts = [];
            prevState.alerts.forEach((item, int, arr) => {
                if (alert.id !== item.id) {
                    newAlerts.push(item);
                }
            });
            prevState.alerts = newAlerts;
            return prevState;
        });
    }

    generateChangeStateProblemsAlert() {
        toast.error("Не удалось сменить статус на запрошенный. Более подробную информацию можно найти на вкладке История.")
    }

    generateNewDocumentsAlert() {
        toast.info("Получены новые документы, вы можете распечатать их на вкладке Документы.")
    }

    generateChangeStatusRequiredFieldsAlert() {
        toast.error("Не удалось сменить статус на запрошенный. Заполните все обязательные поля.")
    }

    handleApplyStatus(nextStatusId, nextStatusName, isConfirmed) {
        if (!this.validateAll()) {
            this.generateChangeStatusRequiredFieldsAlert();
            return;
        }
        let title = 'Изменение статуса посылки ' + this.state.parcel.number;
        let message = 'Вы действительно хотите изменить статус посылки на ' + nextStatusName + '?';

        if (this.state.parcel.carrierServiceCode === "Ya" && nextStatusName === "Отменена") {
            message += '\nВнимание, за отмену заказа может быть выставлена оплата за холостую подачу.';
        }
        this.confirmChangeStatusModal.open(title, message)
            .then(() => {
                this.handleApplyStatusInner(nextStatusId, nextStatusName, isConfirmed);
            })
            .catch(() => {
            });
    }

    handleApplyStatusInner(nextStatusId, nextStatusName, isConfirmed) {
        this.updateBusyCount(1);
        apiPost('parcels/' + this.state.id + '/status/' + nextStatusId + (isConfirmed ? '/confirmed' : ''))
            .then(data => {
                if (data && data.warningMessages) {
                    toast.warning(data.warningMessages, {autoClose: 30000});
                }
                this.updateBusyCount(-1);
                this.processApplyStatusResult(data, nextStatusId, nextStatusName);
            })
            .catch(err => {
                this.updateBusyCount(-1);
                if (err.messages) {
                    this.setState({errors: err.messages});
                    // let title = 'Изменение статуса посылки ' + this.state.parcel.number;
                    let resultMessage = 'Не соблюдены условия для смены статуса посылки:';
                    if (!isNullOrUndefined(err.messages.status)) {
                        resultMessage += '\n' + err.messages.status;
                    }
                    toast.error(resultMessage, {autoClose: 60000})
                }
            });
    }

    processApplyStatusResult(data, nextStatusId, nextStatusName) {
        let title = 'Изменение статуса посылки ' + this.state.parcel.number;
        if (data.needConfirmation) {
            this.confirmModal.open(title, data.confirmationMessage)
                .then(() => {
                    this.handleApplyStatusInner(nextStatusId, nextStatusName, true);
                })
                .catch(() => {
                    this.processApplyStatusSuccessResult(data);
                });
        } else {
            this.processApplyStatusSuccessResult(data);
        }
    }

    processApplyStatusSuccessResult(data) {
        this.reload()
            .then(() => {
                if (data.newDocuments) {
                    this.openTab("docs");
                } else if (data.anotherFinalState || data.stateNotChanged) {
                    this.openTab("history");
                }
                this.setState((prevState, props) => {
                    if (data.stateNotChanged || data.anotherFinalState) {
                        this.generateChangeStateProblemsAlert();
                    }
                    if (data.newDocuments) {
                        this.generateNewDocumentsAlert();
                    }
                    return prevState;
                });
            });
    }

    save(isReadyToSend) {
        let statusSend = this.state.nextStatuses.find(item => item.name === "Отправлена ТК");
        let errors = null;
        if (isReadyToSend) {
            errors = this.costCalcTab.validateForm();
        }
        if (errors) {
            this.setState({errors: errors});
        } else {
            this.handleApplyStatus(statusSend.id, statusSend.name, false);
        }
    }

    onSave(tariff) {
        if (tariff.isRecipientCompanyRequired && (!this.state.parcel.recipientInn || !this.state.parcel.recipientCompanyName)) {
            this.setState({innModal: {open: true}, selectTariff: tariff});
        } else {
            let data = {
                parcelId: this.state.parcel.id,
                entryId: tariff.id,
                isDeliveryTimeSpecified: tariff.isDeliveryTimeSpecified,
                deliveryTime: tariff.isDeliveryTimeSpecified ? tariff.deliveryTime : '',
                recipientInn: this.state.parcel.recipientInn,
                recipientCompanyName: this.state.parcel.recipientCompanyName,
            };
            this.setState({selectTariff: null});
            this.updateBusyCount(1);
            apiPost('parcels/cost/selectAndSend', data)
                .then((res) => {
                    this.updateBusyCount(-1);
                    this.processApplyStatusSuccessResult(res);
                }).catch(err => {
                    this.updateBusyCount(-1);
                    if (err.messages) {
                        this.setState({errors: err.messages});
                        let resultMessage = 'Не соблюдены условия для смены статуса посылки:';
                        if (!isNullOrUndefined(err.messages.status)) {
                            resultMessage += '\n' + err.messages.status;
                        }
                        toast.error(resultMessage, {autoClose: 60000})
                    }
                }
            );
        }
    }

    render() {
        if (this.state.lastResponseError === 403) {
            return <Forbidden/>;
        }
        if (this.state.lastResponseError === 404) {
            return <NotFound/>;
        }

        let isBusy = this.state.busyCount > 0;

        let changeStatusButton = this.state.nextStatuses.length > 0
            ? (
                <StatusChangeModal
                    selectedIds={[Number(this.state.id)]}
                    setLoading={(isLoading) => this.updateBusyCount(isLoading ? 1 : -1)}
                    loading={isBusy}
                    title='Смена статуса посылки'
                    emptyListMessage='Не найдено доступных статусов для перехода'
                    fetchStatuses={() => apiGet('parcels/' + this.state.id + '/status/next')}
                    applyStatus={(nextStatusId) => apiPost('parcels/' + this.state.id + '/status/' + nextStatusId)}
                    onSuccess={(data, selectedOption, nextStatusId) => this.processApplyStatusResult(
                        data,
                        nextStatusId,
                        selectedOption ? selectedOption.text : ''
                    )}
                >
                    <Button
                        className='btn-dropdown parcel-status-change-btn'
                        disabled={isBusy}
                    >
                        <div className='btn-dropdown__icon'>
                            <Status circle code={this.state.parcel.statusCode}/>
                        </div>
                        <span>Изменить статус и сохранить</span>
                        <i aria-hidden="true" className="dropdown icon"></i>
                    </Button>
                </StatusChangeModal>
            ) : null;

        const topBlock = <div className='top-block'>
            <div>
                <div className='c_black'>
                    <b>{this.state.parcel.parcelType
                        ? (this.state.parcel.parcelType === this.state.options.parcelTypes.parcelTypeDoc ? 'Документы' : 'Груз')
                        : ''}</b>
                </div>
                <div>Расч/вес: <span className='c_black'>{this.state.parcel.weight} кг.</span></div>
                <div>Факт/вес: {this.state.parcel.actualWeight
                    ? <b className={this.state.parcel.actualWeight !== this.state.parcel.weight ? 'c_blue' : 'c_black'}>{this.state.parcel.actualWeight} кг.</b>
                    : '-'}</div>
                <div>Объём/вес: {this.state.parcel.volumeWeight
                    ? <span className='c_black'>{this.state.parcel.volumeWeight} кг.</span>
                    : '-'}</div>
            </div>
            <div className='dates'>
                <div>
                    <div
                        className='c_black'>{this.state.parcel.departureDate ? moment(this.state.parcel.departureDate).format('DD.MM.YYYY') : null}</div>
                    <div style={{fontSize: '12px', color: '#475566', marginTop: '4px'}}>Плановая дата отгрузки</div>
                    {this.state.parcel.actualDepartureDate && <div>
                        <div
                            className='c_black' style={{marginTop: '8px'}}>{moment(this.state.parcel.actualDepartureDate).format('DD.MM.YYYY')}</div>
                        <div style={{fontSize: '12px', color: '#475566', marginTop: '4px'}}>Фактическая дата отгрузки</div>
                    </div>}
                </div>
                <div>
                    <div
                        className='c_black'>{
                            (this.state.parcel.selectedTariff && this.state.parcel.selectedTariff.maxDeliveryTime) 
                                ? moment(this.state.parcel.selectedTariff.maxDeliveryTime).format('DD.MM.YYYY')
                                : (this.state.parcel.initialPlannedDeliveryDate 
                                    ? moment(this.state.parcel.initialPlannedDeliveryDate).format('DD.MM.YYYY')
                                    : '-')
                        }</div>
                    <div style={{fontSize: '12px', color: '#475566', marginTop: '4px'}}>Плановая дата доставки</div>
                    {this.state.parcel.actualDeliveryDate && <div>
                        <div
                            className='c_black' style={{marginTop: '8px'}}>{moment(this.state.parcel.actualDeliveryDate).format('DD.MM.YYYY')}</div>
                        <div style={{fontSize: '12px', color: '#475566', marginTop: '4px'}}>Фактическая дата доставки</div>
                    </div>}
                    {this.state.parcel.storagePeriodEnd && <div>
                        <div
                            className='c_black' style={{marginTop: '8px'}}>{moment(this.state.parcel.storagePeriodEnd).format('DD.MM.YYYY')}</div>
                        <div style={{fontSize: '12px', color: '#475566', marginTop: '4px'}}>Срок хранения до</div>
                    </div>}
                    {!this.state.parcel.storagePeriodEnd && this.state.parcel.storagePeriodDays != null && <div>
                        <div
                            className='c_black' style={{marginTop: '8px'}}>{this.state.parcel.storagePeriodDays}</div>
                        <div style={{fontSize: '12px', color: '#475566', marginTop: '4px'}}>Срок хранения, дней</div>
                    </div>}
                </div>
            </div>
            <div>
                <div>
                    <CopyString
                        text={this.state.parcel.shipmentAddressName}
                        onClick={() => {
                            this.setState({
                                maps: {
                                    open: true,
                                    address: this.state.parcel.shipmentAddressName,
                                    coordinates: [(this.state.parcel.shipmentAddress || {}).geoLat, (this.state.parcel.shipmentAddress || {}).geoLon]
                                }
                            })
                        }}
                    >
                        {(this.state.parcel.shipmentAddress || {}).city}
                    </CopyString>
                </div>
                <div>
                    {this.state.parcel.senderCompanyName}
                </div>
                <div>
                    {this.state.parcel.senderName}
                </div>
            </div>
            <div>
                <div>
                    <CopyString
                        text={this.state.parcel.deliveryAddressName}
                        onClick={() => {
                            this.setState({
                                maps: {
                                    open: true,
                                    address: this.state.parcel.deliveryAddressName,
                                    coordinates: [(this.state.parcel.deliveryAddress || {}).geoLat, (this.state.parcel.deliveryAddress || {}).geoLon]
                                }
                            })
                        }}
                    >
                        {(this.state.parcel.deliveryAddress || {}).city}
                    </CopyString>
                </div>
                <div>
                    {this.state.parcel.recipientCompanyName}
                </div>
                <div>
                    {this.state.parcel.recipientName}
                </div>
            </div>
            <div>
                <div className='shipment-company'>
                    {(this.state.parcel.selectedTariff || {}).carrierName ? (
                        <Info
                            name={(this.state.parcel.selectedTariff || {}).carrierName}
                            label={(this.state.parcel.selectedTariff || {}).carrierServiceName}
                            text={(this.state.parcel.selectedTariff || {}).carrierServiceDescription}
                            position={'right'}
                            offset={[7]}
                        />
                    ) : null}
                    <div className='shipment-company__carrier'>
                        <Logos
                            name={(this.state.parcel.selectedTariff || {}).carrierCode}
                            carrierTitle={(this.state.parcel.selectedTariff || {}).carrierName}
                        />
                        {this.state.id && (this.state.parcel.selectedTariff || {}).carrierCode && this.state.parcel.isCarrierReviewAvailable ? (
                            <CarrierReviewRating
                                parcelId={this.state.id}
                                parcel={this.state.parcel}
                                starDimension="16px"
                                starSpacing="2px"
                            />
                        ) : null}
                    </div>
                </div>
            </div>
            <div>
                <div>
                Фактическая стоимость, р. с НДС:
                    <div
                        className={`${this.state.parcel.actualDeliveryCost !== this.state.parcel.deliveryCost ? 'c_blue ' : ''}f-s_18`}>
                        {this.state.parcel.actualDeliveryCost ?
                            <b>{costFormat(this.state.parcel.actualDeliveryCost)} ₽</b> : '-'}
                    </div>
                </div>
                <div>
                    Расчетная стоимость: <span className='c_black'>{costFormat(this.state.parcel.deliveryCost)} ₽</span>
                </div>
            </div>
        </div>

        let panes = [
            {
                menuItem: 'parcelInfo',
                name: 'Отправление',
                pane: <ParcelInfoTab
                    form={this.state.parcel}
                    errors={this.state.errors}
                    options={this.state.options}
                    companyData={this.state.companyData}
                />
            },
            {
                menuItem: 'docs',
                name: 'Документы',
                pane: <DocsTab
                    form={this.state.parcel}
                    documents={this.state.documents}
                    reload={() => this.reload()}
                />
            },
            {
                menuItem: 'costCalc',
                name: 'Расчёт стоимости',
                pane: <div>
                    <CostCalcTab
                        isOpen={this.state.activeTab === 'costCalc'}
                        parcel={this.state.parcel}
                        errors={this.state.errors}
                        isNew={false}
                        isBusy={isBusy}
                        ref={tab => this.costCalcTab = tab}
                        clearErrors={() => this.clearErrors()}
                        reload={() => this.reload()}
                        onFieldChange={(values, save) => this.handleFieldChange(values, save)}
                        onFieldEdited={(name, value) => this.handleFieldEdited(name, value)}
                        onSetErrors={(errors) => this.setErrors(errors)}
                        onSave={(tariff) => this.onSave(tariff)}
                    />
                </div>
            },
            {
                menuItem: 'payer',
                name: 'Плательщик',
                pane: <PayerTab
                    parcel={this.state.parcel}
                    errors={this.state.errors}
                    isNew={false}
                    isBusy={isBusy}
                    ref={tab => this.payerTab = tab}
                    onFieldChange={(name, value) => this.handleFieldChange(name, value)}
                    onFieldEdited={(name, value, ignoreValidation) => this.handleFieldEdited(name, value, ignoreValidation)}
                    onSetErrors={(errors) => this.setErrors(errors)}
                />
            },
            {
                menuItem: 'history',
                name: 'История',
                pane: <HistoryTab
                    history={this.state.history}
                    ref={tab => this.historyTab = tab}
                />
            },
        ]

        const menu = <Menu attached='top' tabular>
            {
                panes.map(item => (
                    ((this.state.parcel.payerTabVisible && item.menuItem === 'payer') || item.menuItem !== 'payer') && <Menu.Item
                        key={item.menuItem}
                        active={this.state.activeTab === item.menuItem}
                        onClick={() => (this.state.activeTab !== item.menuItem) && this.openTab(item.menuItem)}
                    >
                        {item.name}
                    </Menu.Item>
                ))
            }
        </Menu>;

        return (
            <div className='new-styles'>
                <AlertList alerts={this.state.alerts} onDismiss={(item) => this.dismissAlert(item)}/>
                <section className="content-header">
                    <div>
                        <h1>Посылка № {this.state.parcel.number}</h1>
                        {
                            this.state.parcel.statusName && <Status
                                name={this.state.parcel.statusName}
                                code={this.state.parcel.statusCode}
                            />
                        }
                        <div className="buttons-block">
                            {changeStatusButton}
                            <Button
                                onClick={() => this.backToList()}
                                disabled={isBusy}
                            >
                                Закрыть
                            </Button>
                        </div>
                    </div>
                    {this.state.parcel.externalNumber && <div>
                        № <CopyString
                        onClick={this.state.parcel.parcelUrl ? () => window.open(buildParcelExternalTrackingUrl(this.state.parcel.parcelUrl, this.state.parcel.externalNumber), '_blank') : true}>{this.state.parcel.externalNumber}</CopyString>
                    </div>}
                </section>

                <section className='content'>
                    {menu}
                    <Segment vertical>
                        <Dimmer active={isBusy} inverted>
                            <Loader size='medium'/>
                        </Dimmer>
                        {topBlock}
                        {panes.map(p => (
                            <div key={p.menuItem}
                                 className={!(this.state.activeTab === p.menuItem) ? 'sticker-none' : ''}>
                                {p.pane}
                            </div>
                        ))}
                    </Segment>
                </section>

                <InformationModal ref={modal => this.infoModal = modal}/>
                <WarningModal ref={modal => this.warningModal = modal}/>
                <ConfirmModal ref={modal => this.confirmModal = modal}/>
                <ConfirmModal ref={modal => this.confirmChangeStatusModal = modal}/>

                <MapModal
                    open={this.state.maps.open}
                    onClose={() => this.setState({maps: {open: false}})}
                    address={this.state.maps.address}
                    coordinates={this.state.maps.coordinates}
                />

                <InnModal
                    parcel={this.state.parcel}
                    setOpen={(open) => this.setState({innModal: {open}})}
                    open={(this.state.innModal || {}).open}
                    onConfirm={(inn, companyName) => {
                        this.handleFieldChange([
                            {name: 'recipientInn', value: inn},
                            {name: 'recipientCompanyName', value: companyName}
                        ]).then(() => {
                            this.onSave(this.state.selectTariff);
                        });
                    }}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/parcelForm.jsx